import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PlashScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate("/6-introduction");
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-b from-[#ffeaf7] to-[#fff2ea] px-4">
      <img
        className="w-[263px] max-w-full object-contain"
        loading="lazy"
        alt="Splash logo"
        src="/chatgpt-image-13-16-28-5-thg-4-2025-1-1@2x.png"
      />
    </div>
  );
};

export default PlashScreen;